import { useAppContext } from 'src/contexts/AppContext';
import { DEFAULT_CURRENCY_CODE, getCurrencySymbol } from 'src/utils/currency';

/**
 * The current customer's display currency. Chosen once at self-signup;
 * customers created before the feature default to EUR.
 */
export const useCurrency = (): { code: string; symbol: string } => {
  const { currentCustomer } = useAppContext();

  const code = currentCustomer?.currency ?? DEFAULT_CURRENCY_CODE;

  return { code, symbol: getCurrencySymbol(code) };
};
